<script setup>
import { DateTime } from "luxon";
import { computed, ref } from "vue";
import { useAuthStore } from "../pinia/auth.ts";
import { getAclStatus } from "../shared/services/aclStatus.js";
import ThemedButton from "../user/components/ThemedButton.vue";

const authStore = useAuthStore();
const theme = computed(() => authStore.theme?.Accent);
const highContrast = computed(() => authStore.theme?.HighAccessibility);

const props = defineProps({
  expiredAfter: {
    type: String,
    required: false,
  },
  status: {
    type: Number,
    required: true,
  },
  onGrantAcl: {
    type: Function,
  },
  onRevokeAcl: {
    type: Function,
  },
});

const expiresAfter = ref(DateTime.fromISO(props.expiredAfter, { zone: "utc" }));
const expiresDiff = computed(() => (expiresAfter.value ? expiresAfter.value.diffNow("seconds").seconds : null));

const statusData = computed(() => getAclStatus(props.status));
</script>

<template>
  <ThemedButton
    v-if="statusData?.grantIssued || (Boolean(expiresAfter) && expiresDiff > 0)"
    aria-label="Revoke access to Knoc"
    type="button"
    @click="(e) => onRevokeAcl?.(e)"
    data-swapy-no-drag
  >
    Revoke Access
  </ThemedButton>
  <ThemedButton
    v-else-if="statusData?.grantReady"
    aria-label="Grant access to Knoc"
    @click="(e) => onGrantAcl?.(e)"
    type="button"
    data-swapy-no-drag
  >
    Grant Access
  </ThemedButton>
  <ThemedButton
    v-else-if="statusData?.pending"
    aria-label="Pending access to Knoc"
    class="cursor-pointer"
    @click="undefined"
    type="button"
    data-swapy-no-drag
  >
    Pending
  </ThemedButton>
</template>
